(function () {
  'use strict';
  if (window.KoppaAttribution) return;
  var key = 'KOPPA_AMP_ATTR_V1', state;
  var fields = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','gclid','fbclid','msclkid','ttclid'];
  function allowed() { return !!(window.KoppaConsent && window.KoppaConsent.analyticsAllowed()); }
  function read() {
    try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; }
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
    var compact = JSON.parse(JSON.stringify(state));
    var encoded = encodeURIComponent(JSON.stringify(compact));
    ['utm_content','utm_term','fbclid','gclid','msclkid','ttclid'].forEach(function (field) {
      if (encoded.length > 3400) { delete compact.first[field]; delete compact.last[field]; encoded = encodeURIComponent(JSON.stringify(compact)); }
    });
    if (encoded.length <= 3400) document.cookie = key + '=' + encoded + '; Path=/; Max-Age=31536000; SameSite=Lax; Secure';
  }
  function init() {
    if (!allowed()) return;
    if (state) return;
    var now = Date.now(), params = new URLSearchParams(location.search), touch = {}, referrer;
    fields.forEach(function (field) { var value = params.get(field); if (value) touch[field] = value.slice(0,120); });
    try { referrer = new URL(document.referrer); } catch (_) {}
    var external = referrer && referrer.hostname !== location.hostname && !/(^|\.)shopify\.com$|(^|\.)shop\.app$/.test(referrer.hostname);
    touch.landing_page = location.pathname.slice(0,160);
    touch.referring_domain = external ? referrer.hostname.slice(0,120) : '';
    touch.attribution_source = touch.utm_source || touch.gclid || touch.fbclid || touch.msclkid || touch.ttclid ? 'campaign' : (external ? 'referral' : 'direct');
    var previous = read();
    if (!previous || previous.version !== 1 || !previous.first || !previous.last) previous = null;
    var newTouch = !previous || now - previous.at > 1800000 || touch.attribution_source === 'campaign' || external;
    state = {version:1, first:previous ? previous.first : touch, last:newTouch ? touch : previous.last, at:now};
    persist();
  }
  function context() {
    if (!allowed()) return {};
    init();
    var props = Object.assign({}, state.last);
    Object.keys(state.first).forEach(function (field) { props['initial_' + field] = state.first[field]; });
    return props;
  }
  function clear() {
    state = null;
    try { localStorage.removeItem(key); } catch (_) {}
    document.cookie = key + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
  }
  window.KoppaAttribution = {context:context, state:function () { init(); return allowed() ? state : null; }};
  window.addEventListener('koppa:consent', function () {
    if (allowed()) init();
    else if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'no') clear();
  });
  window.addEventListener('koppa:analytics-denied', clear);
  init();
})();
